/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `NotificationListsUser.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { NotificationListsUser } from "./NotificationListsUser";

import { NotificationList } from "./NotificationList";
import { User } from "./User";

export abstract class NotificationListsUserModel {
    id: number;
    notificationListId: number;
    userId: number;
    notificationList: NotificationList | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        notificationListId: number,
        userId: number,
        notificationList: NotificationList | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.notificationListId = notificationListId;
        this.userId = userId;
        this.notificationList = notificationList;
        this.user = user;
    }

    static fromApiObject(json: any, timezone: string): NotificationListsUser {
        const newObject = new NotificationListsUser(
            json["id"],
            json["notification_list_id"],
            json["user_id"],
            json["notification_list"] == null
                ? json["notification_list"]
                : NotificationList.fromApiObject(json["notification_list"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            notification_list_id: this.notificationListId,
            user_id: this.userId,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): NotificationListsUser {
        const clone = Object.create(this) as NotificationListsUser;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
